"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateFieldFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactDatePicker = _interopRequireDefault(require("@adsk/alloy-react-date-picker"));
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _useTranslations = require("../../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DateFieldFooter = _ref => {
  let {
    reset,
    toggleOverlay,
    disabled = false,
    children
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement(_alloyReactDatePicker.default.Footer, null, /*#__PURE__*/_react.default.createElement("div", null, children ? /*#__PURE__*/_react.default.createElement("div", null, children) : null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
    style: {
      padding: 0
    },
    variant: _alloyReactButton.default.VARIANTS.TERTIARY,
    size: _alloyReactButton.default.SIZES.SMALL,
    onClick: () => {
      reset();
      toggleOverlay();
    },
    disabled: disabled
  }, T.translate("dateFilter.clearDates")))));
};
exports.DateFieldFooter = DateFieldFooter;
//# sourceMappingURL=DateFieldFooter.js.map